import React, { useMemo } from 'react';

import { Box } from '@mui/system';
import { Combobox } from '@bestdoctor/spectrum-uikit/Combobox';
import type { ComboboxOption } from '@bestdoctor/spectrum-uikit/Combobox';

import { Company, DataPeriod, ProgramsFiltersProps } from 'interfaces/global/globalInterfaces';
import { mainFiltersContainerStyle, mainFiltersSectionStyle, mainFiltersWrapperStyle } from 'ui/patients/mainFilters';

export const ProgramsFilters: React.FC<ProgramsFiltersProps> = ({
  dataPeriods,
  allCompanies,

  selectedCompanyByProgram,
  handleSelectedCompanyByProgram,

  selectedPeriodByProgram,
  handleSelectedPeriodByProgram,
}) => {
  // Преобразуем компании в формат ComboboxOption
  const companyOptions: ComboboxOption<Company>[] = useMemo(
    () =>
      (allCompanies || []).map((company) => ({
        label: company.title,
        value: company,
      })),
    [allCompanies]
  );

  // Преобразуем периоды в формат ComboboxOption
  const periodOptions: ComboboxOption<DataPeriod>[] = useMemo(
    () =>
      (selectedCompanyByProgram ? dataPeriods || [] : []).map((period) => ({
        label: period.title,
        value: period,
      })),
    [dataPeriods, selectedCompanyByProgram]
  );

  // Находим текущую выбранную опцию компании
  const selectedCompanyOption = useMemo(
    () => companyOptions.find((option) => option.value.uuid === selectedCompanyByProgram?.uuid) || null,
    [companyOptions, selectedCompanyByProgram]
  );

  // Находим текущую выбранную опцию периода
  const selectedPeriodOption = useMemo(
    () => periodOptions.find((option) => option.value.uuid === selectedPeriodByProgram?.uuid) || null,
    [periodOptions, selectedPeriodByProgram]
  );

  return (
    <Box component="section" sx={mainFiltersSectionStyle}>
      <Box sx={mainFiltersWrapperStyle}>
        <Box sx={mainFiltersContainerStyle}>
          <Combobox<Company>
            label="Компания"
            placeholder="Компания"
            options={companyOptions}
            value={selectedCompanyOption?.value}
            searchable
            clearable
            size='m'
            onChange={(value, option) => {
              if (value && option) {
                sessionStorage.setItem('mainFilterCompanyPrograms', JSON.stringify(value));
                sessionStorage.setItem('mainFilterPeriodPrograms', JSON.stringify(''));
                handleSelectedCompanyByProgram(value);
              } else {
                sessionStorage.setItem('mainFilterCompanyPrograms', JSON.stringify(''));
                sessionStorage.setItem('mainFilterPeriodPrograms', JSON.stringify(''));
                handleSelectedCompanyByProgram(null);
              }
            }}
          />
        </Box>
        <Box sx={{ width: '100%' }}>
          <Combobox<DataPeriod>
            label="Период данных"
            placeholder="Период данных"
            options={periodOptions}
            value={selectedPeriodOption?.value}
            searchable
            clearable
            size='m'
            disabled={!selectedCompanyByProgram}
            onChange={(value, option) => {
              if (value && option) {
                sessionStorage.setItem('mainFilterPeriodPrograms', JSON.stringify(value));
                handleSelectedPeriodByProgram(value);
              } else {
                sessionStorage.setItem('mainFilterPeriodPrograms', JSON.stringify(''));
                handleSelectedPeriodByProgram(null);
              }
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
